import { ptBRAccessControlPageTranslation } from './access-control';
import { ptBRHomeTranslation } from './home';
import { ptBRMeritocracyPageTranslation } from './meritocracy';
import { ptBRMeritocracyParamatersPageTranslation } from './meritocracy-parameters';
import { ptBRYourDataPageTranslation } from './your-data';

export const ptBRPagesTranslation = {
  ...ptBRMeritocracyPageTranslation,
  ...ptBRMeritocracyParamatersPageTranslation,
  ...ptBRAccessControlPageTranslation,
  ...ptBRHomeTranslation,
  ...ptBRYourDataPageTranslation,
};
